import React, { useEffect, useState } from "react";
import { CheckCircleOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Popconfirm, Table, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import { useVoyage } from "../../../context/VoyageContext";

const VoyageListingStaff = () => {
  const navigate = useNavigate();
  const [loader, set_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [isRunning, setRunningState] = useState(true);
  const { updateVoyage } = useVoyage();

  const VOYAGE_LIST_API = () => {
    try {
      set_loader(true);
      const FORM_DATA = new FormData();
      post(ApiURL.list_voyage_info, FORM_DATA)
        .then((res) => {
          if (res?.status == true) {
            const voyages = res?.voyage || [];
            const hasActiveVoyage = voyages.some(
              (voyage) => voyage?.voyage_status === true
            );
            updateVoyage({ status: hasActiveVoyage });
            setRunningState(hasActiveVoyage);
            setFilteredData(voyages);
          }
        })
        .finally(() => {
          set_loader(false);
        });
    } catch (error) {
      console.error("Error fetching Voyage list:", error);
      set_loader(false);
    }
  };

  const Get_Staff_Dashboard_Details = () => {
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.staff_dashboard, FORM_DATA)
        .then((res) => {
          if (res?.status == true) {
            const dashboardData = res?.data || null;
            localStorage.setItem(
              "staff_dashboard",
              JSON.stringify(dashboardData)
            );
          } else {
            console.error("Error: Response status is false.");
            localStorage.setItem("staff_dashboard", JSON.stringify(null));
          }
        })
        .catch((error) => {
          console.error("API call error:", error);
          localStorage.setItem("staff_dashboard", JSON.stringify(null));
        });
    } catch (error) {
      console.error("Error fetching Staff Dashboard data:", error);
    }
  };

  const checkAndUpdateVoyageStatus = (record, current_status) => {
    const isAnyRunning = filteredData.some(
      (voyage) => voyage.voyage_status === true && voyage.id !== record
    );
    if (current_status === false && isAnyRunning) {
      ErrorToast(
        "Error",
        "Please complete current voyage before starting a new one."
      );
    } else {
      VOYAGE_STATUS_API(record?.id);
    }
  };

  const VOYAGE_STATUS_API = (record_id) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("voyage_id", record_id);
    post(ApiURL.voyage_status_st, FORM_DATA).then((res) => {
      if (res?.status == true) {
        SuccessToast("Success message !!", res?.message);
        Get_Staff_Dashboard_Details();
        VOYAGE_LIST_API();
      } else {
        ErrorToast("Error message", res?.message);
      }
    });
  };

  const VOYAGE_DELETE_API = async (id) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("id", id);
      post(ApiURL.delete_voyage_info, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("Success!!", "Voyage Details Successfully deleted.");
          set_loader(false);
        } else {
          ErrorToast("Error", "sorry staff details not deleted ");
          set_loader(false);
        }
      });
    } catch (error) {
      set_loader(false);
    }
  };

  useEffect(() => {
    VOYAGE_LIST_API();
  }, []);

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      align: "center",
      key: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Role",
      dataIndex: "role",
      align: "center",
      key: "role",
    },
    {
      title: "Vessel Name",
      dataIndex: "ship_name",
      align: "center",
      key: "ship_name",
    },
    {
      title: "Voyage No",
      dataIndex: "voyage_no",
      align: "center",
      key: "voyage_no",
    },
    {
      title: "Voyage Type",
      dataIndex: "voyage_type",
      align: "center",
      key: "voyage_type",
    },
    {
      title: "Voyage Status",
      dataIndex: "voyage_status",
      align: "center",
      key: "voyage_status",
      render: (text, record) => {
        if (record.voyage_status) {
          return <span className="table-status-running">Running</span>;
        } else {
          return <span className="table-status-completed">Completed</span>;
        }
      },
    },
    {
      title: "Created Date",
      dataIndex: "created_date",
      align: "center",
      key: "created_date",
      render: (text, record) => {
        if (!record?.voyage_date) return "N/A";
        const date = new Date(record.voyage_date);
        return date.toISOString().slice(0, 10);
      },
    },
    {
      title: "Action",
      align: "center",
      key: "Action",
      render: (text, record) => (
        <>
          <Tooltip title="Change Status">
            <Popconfirm
              title="Change Voyage Status"
              description={`Do you want to change the status of this voyage?`}
              onConfirm={() =>
                checkAndUpdateVoyageStatus(record, record?.voyage_status)
              }
              okText="Yes"
              cancelText="No"
            >
              <Button
                type="primary"
                size="small"
                style={{ marginRight: "15px" }}
                icon={<CheckCircleOutlined />}
              />
            </Popconfirm>
          </Tooltip>

          <Tooltip title="View Voyage">
            <Button
              type="primary"
              size="small"
              onClick={() => navigate(`/voyage-view/${btoa(record.id)}`)}
              style={{ marginRight: "15px" }}
              icon={<EditOutlined />}
            />
          </Tooltip>
        </>
      ),
    },
  ];

  return (
    <>
      <div>
        <div className="row" style={{ padding: "10px" }}>
          <div
            className="col-3"
            style={{ marginLeft: "5px", alignSelf: "end" }}
          >
            <div className="theme-content-title text-left">
              <h3>Voyage List</h3>
            </div>
          </div>
          <div className="col-3"></div>
          <div
            className="col-6"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <div className="d-flex align-items-center">
              {!isRunning && (
                <Button
                  type="primary"
                  className="save_btn"
                  onClick={() => navigate("/voyage-add")}
                  style={{ marginRight: "10px" }}
                >
                  Add Voyage
                </Button>
              )}
              <Button
                type="primary"
                className="save_btn"
                onClick={() => navigate("/audit-trail-staff-voyage")}
              >
                Audit Trail
              </Button>
            </div>
          </div>
        </div>

        <Table
          bordered
          loading={loader}
          columns={columns}
          dataSource={filteredData}
          pagination={{ pageSize: 10 }}
          rowKey="key"
          className="custom-table"
        />
      </div>
    </>
  );
};

export default VoyageListingStaff;
